import { createFileRoute, redirect } from '@tanstack/react-router';
import { VerifyEmailPage } from '@/features/auth/pages/verify-email-page';
import { isApiError } from '@/lib/api';
import { signInSearch } from '@/lib/home';
import { meQueryOptions } from '@/lib/me';

/**
 * "Confirm your email" gate after an email sign-up. Needs a session. The emailed link lands here with `done=1`
 * (verified) or `error=<code>` (expired / invalid link); `industry` and `plan` ride along to the create-shop step.
 */
export const Route = createFileRoute('/verify-email')({
  validateSearch: (
    s: Record<string, unknown>,
  ): { industry?: string; plan?: string; done?: boolean; error?: string } => ({
    industry: typeof s.industry === 'string' && s.industry ? s.industry : undefined,
    plan: typeof s.plan === 'string' && s.plan ? s.plan : undefined,
    // the router parses `?done=1` into the number 1
    done: String(s.done) === '1' ? true : undefined,
    error: typeof s.error === 'string' && s.error ? s.error : undefined,
  }),
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(meQueryOptions);
    } catch (e) {
      if (isApiError(e) && e.status === 401)
        throw redirect({ to: '/sign-in', search: signInSearch(location.href) });
      throw e;
    }
  },
  component: VerifyEmailPage,
});
